import PartnerProgramBanner from 'pricing-pages-ui-components/banners/PartnerProgramBanner';
import { getPartnerProgramUrl } from 'pricing-pages-ui-components/utils/partnerProgramUtils';
import { trackClickedLink } from '../../v2/utils/tracking/trackingEventUtils';
import { usePartnerProgramBanner } from '../../v2/hooks/banners/usePartnerProgramBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const PartnerProgramBannerContainer = () => {
  const {
    shouldShowPartnerProgramBanner,
    dismissBanner
  } = usePartnerProgramBanner();
  const handlePartnerProgramLinkClick = () => {
    trackClickedLink({
      name: 'partner-banner-more-info',
      value: 'Click here',
      type: 'external',
      url: getPartnerProgramUrl()
    });
  };
  if (!shouldShowPartnerProgramBanner) {
    return null;
  }
  return /*#__PURE__*/_jsx(PartnerProgramBanner, {
    onLinkClick: handlePartnerProgramLinkClick,
    onClose: dismissBanner
  });
};
export default PartnerProgramBannerContainer;